<div class="price-container">
  <div class="price">
    @if (hotel?.rate?.price?.discount?.amount && hotel?.rate?.price?.discount?.percentage >= 5) {
      <mb-advice [align]="mbAdvicePosition" color="success" class="price__gift">
        {{ hotel.rate.price.discount.percentage }}% OFF
      </mb-advice>
    }
    @if (hotel.rate?.isExperts) {
      <div class="price__hotel-provider">
        {{ hotel.rate.provider }}
      </div>
    }
    <div class="price__amount">
      @if (!isAlliance) {
        @if (
          hotel?.rate?.price?.discount?.amount &&
          hotel?.rate?.price?.discount?.percentage >= 5 &&
          (hotel.rate.price.total_without_discount ||
            hotel.rate.price.per_night_per_room_without_discount)
        ) {
          <div class="price__amount__price-without-discount">
            @if (currencyCode === 'USD') {
              <span>u$s&nbsp;</span>
            } @else {
              <span>$&nbsp;</span>
            }
            <strong><s>{{
                query?.queryParams?.priceBy === 'TOTAL'
                ? (hotel.rate.price.total_without_discount | Currency)
                : (hotel.rate.price.per_night_per_room_without_discount | Currency)
                }}</s></strong>
          </div>
        }
        <div class="price__amount__price">
          @if (query?.queryParams?.priceBy === 'TOTAL') {
            <strong>Precio total</strong>
            @if (currencyCode === 'USD') {
              <span class="sign">u$s
                <strong>{{ totalPrice | Currency }} </strong>
              </span>
            } @else {
              <span class="sign">$
                <strong>{{ totalPrice | Currency }} </strong>
              </span>
            }
          }
          @if (query?.queryParams?.priceBy !== 'TOTAL') {
            <strong>Precio por noche</strong>
            @if (currencyCode === 'USD') {
              <span class="sign">u$s
                <strong>{{ totalPerNight | Currency }} </strong>
              </span>
            } @else {
              <span class="sign">$
                <strong>{{ totalPerNight | Currency }} </strong>
              </span>
            }
          }
        </div>
        <div class="detail-price" [ngClass]="{'endJustify':isMobile}">
          <ng-container *ngTemplateOutlet="taxes"></ng-container>
          @if (query?.queryParams?.priceBy === 'TOTAL') {
            <div class="price__secondary_price total-price">
              <span class="price_value">Precio por noche</span>
              @if (currencyCode === 'USD') {
                <span class="price_value">u$s {{ totalPerNight | Currency }} </span>
              } @else {
                <span class="price_value">$ {{ totalPerNight | Currency }} </span>
              }
            </div>
          }
          @if (!isLanding && query?.queryParams?.priceBy !== 'TOTAL') {
            <div class="price__secondary_price total-price">
              <span class="price_value">Precio total</span>
              @if (currencyCode === 'USD') {
                <span class="price_value">u$s {{ totalPrice | Currency }} </span>
              } @else {
                <span class="price_value">$ {{ totalPrice | Currency }} </span>
              }
            </div>
          }
        </div>

      } @else {
        <am-rewards-pricing [price]="superclubPrice"></am-rewards-pricing>
      }
      <ng-container>
        <div class="pricing-no-tax" [ngClass]="{'mobile-taxes':isMobile}">
          <span>Precio sin impuestos nacionales</span>
          <span>
            {{currencyCode === 'USD'? 'u$s':'$'}}
            {{
            totalWithoutIva | Currency
            }}</span>
        </div>
      </ng-container>
      @if (isMobile) {
        <am-pricing-expandable [rateId]="hotel.rate.id" [fop]="paymentMethodText" [currencyCode]="currencyCode"
          #princingExpandable></am-pricing-expandable>
      } @else {
        <am-pricing-popover [rateId]="hotel.rate.id" [fop]="paymentMethodText" [currencyCode]="currencyCode"
          #pricingPopover>
        </am-pricing-popover>
      }

      <div class="price__button_container">
        <button class="--button-fullwidth" mb-button variant="principal" color="primary" (click)="redirectToDetail()">
          Ver alojamiento
        </button>
      </div>
      @if (viewPaymentMethodButton) {
        <div class="payment_method">
          <button mb-button variant="link" color="secondary" (click)="openDialogPaymentMethod()"><mb-icon
              icon="wallet"></mb-icon> Metodos de pago</button>
        </div>
      }
      <!--am-experts-compensation [channel]="'web'" [margin]="commission" [productType]="'HOTEL'" [brand]="context.brand"
        [channel]="context.channel" [language]="context.language" [locale]="context.locale" [site]="context.site"
        [currency]='currencyToCompensation'>
      </!--am-experts-compensation-->
    </div>
  </div>
</div>

<ng-template #taxes>
  <div class="description-taxes" [class.special-taxes]="!isArgentinian && currencyCode === 'ARS'">
    <p>
      @if (isArgentinian || (!isArgentinian && currencyCode !== 'ARS')) {
        <span>Impuestos incluidos</span>
      }
      @if (paymentMethodText === 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode === 'ARS') {
        <span>Podría cobrarse la percepción RG5617</span>
      }
      @if (paymentMethodText !== 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode === 'ARS') {
        <span>No se te cobrará la percepción RG5617</span>
      }
      <mb-icon icon="info" class="icon-focus" (click)="isMobile ? expandBreakdown() : showPopover()"></mb-icon>
    </p>
  </div>
</ng-template>